/* eslint-disable import/no-anonymous-default-export */
export default (
  renew = { success: null, error: null, insurance: [] },
  action
) => {
  switch (action.type) {
    case "GET_CURRENT_INSURANCE":
      return { ...renew, insurance: action.payload };
    case "RENEW_INSURANCE":
      return { ...renew, success: action.payload };

    default:
      return renew;
  }
};
